import { render, staticRenderFns } from "./storeCollection.vue?vue&type=template&id=43bf8c86&scoped=true"
import script from "./storeCollection.vue?vue&type=script&lang=js"
export * from "./storeCollection.vue?vue&type=script&lang=js"
import style0 from "./storeCollection.vue?vue&type=style&index=0&id=43bf8c86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bf8c86",
  null
  
)

export default component.exports